import { useDialog } from "@shared/features/dialog/useDialog";
import { SchedulingDialog } from "@platform/features/scheduling/components/SchedulingDialog/SchedulingDialog";
import { useProgram } from "../../hooks/useProgram";

export function ProgramScheduleFormContainer() {
  const { activeDialog, closeDialog, dialogProps } = useDialog();

  const isOpen = activeDialog === "scheduling";

  const { program } = useProgram();

  if (!program) return null;

  const handleDone = async () => {
    // close the dialog
    closeDialog("scheduling");
  };

  return (
    <SchedulingDialog
      onDone={handleDone}
      onClose={handleDone}
      isOpen={isOpen}
      programId={parseInt(program.id, 10)}
      userPhaseActionId={dialogProps?.userPhaseActionId}
    />
  );
}

export default ProgramScheduleFormContainer;
